





import VideoPlayer from '@getaccept/lib-shared/src/video/player/components/VideoPlayer.vue';
import type { SigningPageVideo } from '@getaccept/lib-shared/src/types/signing-page-video';
import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  components: {
    VideoPlayer,
  },
  props: {
    video: {
      type: Object as PropType<SigningPageVideo>,
      required: true,
    },
  },
  setup(_props, { emit }) {
    const handleClose = () => {
      emit('close');
    };

    return {
      handleClose,
    };
  },
});
